<style lang="scss" scoped>
@use '~@/styles/main';
@use '~@/styles/base/variables';

.menu-wrapper {
  position: fixed;
  height: 100%;
  z-index: 1000;
  top: 0;
  left: 0;
}

.toggle-button {
  bottom: 10px;
  right: -10px;
}

.menu {
  width: variables.$menu-width;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding-top: 30px;
  padding-bottom: 10px;
  background-color: var(--color-background-dark);
  text-align: center;
}

.logo {
  animation: spin 4s linear;

  &-wrapper {
    margin-bottom: 10px;
  }
}

.item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: var(--color-neutral);
  border-radius: 3px;
  font-size: 10px;
  width: variables.$menu-width;
  height: 65px;
  cursor: pointer;
  transition: all 0.3s;
  fill: var(--color-neutral);

  &__title {
    margin-top: 5px;
  }

  &:hover:not(.item_active) {
    color: var(--color-text);
    fill: var(--color-text);
    font-weight: bold;
  }

  &_gap {
    margin-top: 25px;
  }

  &_active {
    color: var(--color-accent-light);
    fill: var(--color-accent-light);
    font-weight: bold;
  }
}

.exit {
  &__img {
    fill: var(--color-neutral);
  }
}

.version {
  color: var(--color-card);
  font-size: 13px;
  font-weight: bold;
}

.version:hover {
  background: linear-gradient(
    to bottom left,
    var(--color-accent-dark),
    var(--color-accent-light)
  );
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

@keyframes spin {
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media all and (max-height: 500px) {
  .menu {
    .item_gap {
      margin-top: 0px;
    }
  }
}

@media screen and (max-width: variables.$xs) {
  .logo-wrapper {
    display: none;
  }

  .menu-wrapper {
    top: unset;
    left: unset;
    bottom: 0;
    width: 100%;
    height: variables.$mobile-menu-height;
  }

  .menu {
    width: 100%;
    flex-direction: row;
    padding: 0;
    box-shadow: 0 -2px 10px var(--color-background-dark);
  }

  .item {
    flex: 1;

    &__img {
      width: 40px;
      height: 40px;
    }

    &__title {
      display: none;
    }

    &_gap {
      margin-top: 0;
    }
  }

  .exit-wrapper {
    display: none;
  }
}
</style>

<template>
  <div class="menu-wrapper">
    <div
      id="menu"
      class="menu noselect"
    >
      <div class="logo-wrapper">
        <img
          class="logo"
          src="../assets/logo-only.png"
          width="24px"
        />
      </div>
      <router-link
        v-for="(item, key) in menuItems"
        :key="key"
        class="item item_gap"
        :to="item.href"
        :class="{ item_active: $route.path === item.href }"
      >
        <svg
          v-if="item.img === 'portfolio'"
          class="item__img"
          width="21px"
          height="21px"
          viewBox="0 0 110 110"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M36 7C36 6.44772 36.4477 6 37 6H62C62.5523 6 63 6.44772 63 7V15.5H36V7ZM30 15.5V7C30 3.13401 33.134 0 37 0H62C65.866 0 69 3.13401 69 7V15.5H92C95.3137 15.5 98 18.1863 98 21.5V58.5C98 61.8137 95.3137 64.5 92 64.5H66V67.5C66 70.8137 63.3137 73.5 60 73.5H38C34.6863 73.5 32 70.8137 32 67.5V64.5H6C2.68629 64.5 0 61.8137 0 58.5V21.5C0 18.1863 2.68629 15.5 6 15.5H30ZM92 21.5H6L6 58.5H32V55.5C32 52.1863 34.6863 49.5 38 49.5H60C63.3137 49.5 66 52.1863 66 55.5V58.5H92V21.5ZM59 64.5V58.5V56.5H39V58.5V64.5V66.5H59V64.5ZM7.5 70C9.80022 70 10.5 71.3431 10.5 73V88.5C10.5 90.1569 11.8431 91.5 13.5 91.5H85C86.6582 91.5 88 90.1576 88 88.5021V88.475V88.448V88.4208V88.3936V88.3664V88.3392V88.3119V88.2846V88.2572V88.2298V88.2023V88.1748V88.1473V88.1197V88.0921V88.0645V88.0368V88.0091V87.9813V87.9535V87.9257V87.8978V87.8699V87.8419V87.8139V87.7859V87.7578V87.7297V87.7016V87.6734V87.6452V87.6169V87.5887V87.5603V87.532V87.5036V87.4751V87.4467V87.4182V87.3896V87.3611V87.3325V87.3038V87.2751V87.2464V87.2177V87.1889V87.1601V87.1312V87.1023V87.0734V87.0445V87.0155V86.9865V86.9574V86.9283V86.8992V86.8701V86.8409V86.8117V86.7824V86.7531V86.7238V86.6945V86.6651V86.6357V86.6062V86.5768V86.5473V86.5177V86.4882V86.4586V86.4289V86.3993V86.3696V86.3399V86.3101V86.2803V86.2505V86.2207V86.1908V86.1609V86.131V86.1011V86.0711V86.0411V86.011V85.9809V85.9509V85.9207V85.8906V85.8604V85.8302V85.7999V85.7697V85.7394V85.7091V85.6787V85.6483V85.6179V85.5875V85.5571V85.5266V85.4961V85.4655V85.435V85.4044V85.3738V85.3431V85.3125V85.2818V85.2511V85.2203V85.1896V85.1588V85.128V85.0972V85.0663V85.0354V85.0045V84.9736V84.9426V84.9116V84.8806V84.8496V84.8186V84.7875V84.7564V84.7253V84.6941V84.663V84.6318V84.6006V84.5694V84.5381V84.5069V84.4756V84.4442V84.4129V84.3816V84.3502V84.3188V84.2874V84.2559V84.2245V84.193V84.1615V84.13V84.0984V84.0669V84.0353V84.0037V83.9721V83.9404V83.9088V83.8771V83.8454V83.8137V83.782V83.7502V83.7185V83.6867V83.6549V83.6231V83.5912V83.5594V83.5275V83.4956V83.4637V83.4318V83.3999V83.3679V83.3359V83.304V83.272V83.2399V83.2079V83.1758V83.1438V83.1117V83.0796V83.0475V83.0154V82.9832V82.9511V82.9189V82.8867V82.8545V82.8223V82.7901V82.7579V82.7256V82.6933V82.6611V82.6288V82.5965V82.5641V82.5318V82.4995V82.4671V82.4347V82.4024V82.37V82.3376V82.3052V82.2727V82.2403V82.2078V82.1754V82.1429V82.1104V82.0779V82.0454V82.0129V81.9804V81.9478V81.9153V81.8827V81.8502V81.8176V81.785V81.7524V81.7198V81.6872V81.6546V81.622V81.5893V81.5567V81.524V81.4914V81.4587V81.426V81.3933V81.3606V81.3279V81.2952V81.2625V81.2298V81.1971V81.1643V81.1316V81.0988V81.0661V81.0333V81.0006V80.9678V80.935V80.9022V80.8694V80.8366V80.8038V80.771V80.7382V80.7054V80.6726V80.6398V80.6069V80.5741V80.5413V80.5084V80.4756V80.4427V80.4099V80.377V80.3442V80.3113V80.2785V80.2456V80.2127V80.1799V80.147V80.1141V80.0813V80.0484V80.0155V79.9826V79.9497V79.9169V79.884V79.8511V79.8182V79.7853V79.7524V79.7195V79.6867V79.6538V79.6209V79.588V79.5551V79.5222V79.4893V79.4565V79.4236V79.3907V79.3578V79.3249V79.292V79.2592V79.2263V79.1934V79.1606V79.1277V79.0948V79.062V79.0291V78.9962V78.9634V78.9305V78.8977V78.8648V78.832V78.7991V78.7663V78.7335V78.7007V78.6678V78.635V78.6022V78.5694V78.5366V78.5038V78.471V78.4382V78.4054V78.3727V78.3399V78.3071V78.2744V78.2416V78.2089V78.1761V78.1434V78.1106V78.0779V78.0452V78.0125V77.9798V77.9471V77.9144V77.8818V77.8491V77.8164V77.7838V77.7511V77.7185V77.6859V77.6532V77.6206V77.588V77.5554V77.5229V77.4903V77.4577V77.4252V77.3926V77.3601V77.3276V77.2951V77.2625V77.2301V77.1976V77.1651V77.1326V77.1002V77.0678V77.0353V77.0029V76.9705V76.9381V76.9057V76.8734V76.841V76.8087V76.7763V76.744V76.7117V76.6794V76.6472V76.6149V76.5826V76.5504V76.5182V76.486V76.4538V76.4216V76.3894V76.3573V76.3251V76.293V76.2609V76.2288V76.1967V76.1647V76.1326V76.1006V76.0686V76.0366V76.0046V75.9726V75.9407V75.9087V75.8768V75.8449V75.813V75.7812V75.7493V75.7175V75.6857V75.6539V75.6221V75.5903V75.5586V75.5268V75.4951V75.4635V75.4318V75.4001V75.3685V75.3369V75.3053V75.2737V75.2422V75.2106V75.1791V75.1476V75.1161V75.0847V75.0532V75.0218V74.9904V74.9591V74.9277V74.8964V74.8651V74.8338V74.8025V74.7712V74.74V74.7088V74.6776V74.6465V74.6153V74.5842V74.5531V74.5221V74.491V74.46V74.429V74.398V74.3671V74.3362V74.3053V74.2744V74.2435V74.2127V74.1819V74.1511V74.1203V74.0896V74.0589V74.0282V73.9976V73.9669V73.9363V73.9057V73.8752V73.8446V73.8141V73.7837V73.7532V73.7228V73.6924V73.662V73.6317V73.6014V73.5711V73.5408V73.5106V73.4804V73.4502V73.42V73.3899V73.3598V73.3297V73.2997V73.2697V73.2397V73.2098V73.1798V73.1499V73.1201V73.0903V73.0604V73.0307V73.0009V73V72.9712V72.9415V72.9119V72.8823V72.8527V72.8231V72.7936V72.7641V72.7346V72.7052V72.6758V72.6464V72.617V72.5877V72.5585V72.5292V72.5H88.0317C88.2162 71.0811 89.2056 70 91 70C93.0637 70 93.8392 71.0811 93.9768 72.5H94V72.5292V72.5585V72.5877V72.617V72.6464V72.6758V72.7052V72.7346V72.7641V72.7936V72.8231V72.8527V72.8823V72.9119V72.9415V72.9712V73V73.0009V73.0307V73.0604V73.0903V73.1201V73.1499V73.1798V73.2098V73.2397V73.2697V73.2997V73.3297V73.3598V73.3899V73.42V73.4502V73.4804V73.5106V73.5408V73.5711V73.6014V73.6317V73.662V73.6924V73.7228V73.7532V73.7837V73.8141V73.8446V73.8752V73.9057V73.9363V73.9669V73.9976V74.0282V74.0589V74.0896V74.1203V74.1511V74.1819V74.2127V74.2435V74.2744V74.3053V74.3362V74.3671V74.398V74.429V74.46V74.491V74.5221V74.5531V74.5842V74.6153V74.6465V74.6776V74.7088V74.74V74.7712V74.8025V74.8338V74.8651V74.8964V74.9277V74.9591V74.9904V75.0218V75.0532V75.0847V75.1161V75.1476V75.1791V75.2106V75.2422V75.2737V75.3053V75.3369V75.3685V75.4001V75.4318V75.4635V75.4951V75.5268V75.5586V75.5903V75.6221V75.6539V75.6857V75.7175V75.7493V75.7812V75.813V75.8449V75.8768V75.9087V75.9407V75.9726V76.0046V76.0366V76.0686V76.1006V76.1326V76.1647V76.1967V76.2288V76.2609V76.293V76.3251V76.3573V76.3894V76.4216V76.4538V76.486V76.5182V76.5504V76.5826V76.6149V76.6472V76.6794V76.7117V76.744V76.7763V76.8087V76.841V76.8734V76.9057V76.9381V76.9705V77.0029V77.0353V77.0678V77.1002V77.1326V77.1651V77.1976V77.2301V77.2625V77.2951V77.3276V77.3601V77.3926V77.4252V77.4577V77.4903V77.5229V77.5554V77.588V77.6206V77.6532V77.6859V77.7185V77.7511V77.7838V77.8164V77.8491V77.8818V77.9144V77.9471V77.9798V78.0125V78.0452V78.0779V78.1106V78.1434V78.1761V78.2089V78.2416V78.2744V78.3071V78.3399V78.3727V78.4054V78.4382V78.471V78.5038V78.5366V78.5694V78.6022V78.635V78.6678V78.7007V78.7335V78.7663V78.7991V78.832V78.8648V78.8977V78.9305V78.9634V78.9962V79.0291V79.062V79.0948V79.1277V79.1606V79.1934V79.2263V79.2592V79.292V79.3249V79.3578V79.3907V79.4236V79.4565V79.4893V79.5222V79.5551V79.588V79.6209V79.6538V79.6867V79.7195V79.7524V79.7853V79.8182V79.8511V79.884V79.9169V79.9497V79.9826V80.0155V80.0484V80.0813V80.1141V80.147V80.1799V80.2127V80.2456V80.2785V80.3113V80.3442V80.377V80.4099V80.4427V80.4756V80.5084V80.5413V80.5741V80.6069V80.6398V80.6726V80.7054V80.7382V80.771V80.8038V80.8366V80.8694V80.9022V80.935V80.9678V81.0006V81.0333V81.0661V81.0988V81.1316V81.1643V81.1971V81.2298V81.2625V81.2952V81.3279V81.3606V81.3933V81.426V81.4587V81.4914V81.524V81.5567V81.5893V81.622V81.6546V81.6872V81.7198V81.7524V81.785V81.8176V81.8502V81.8827V81.9153V81.9478V81.9804V82.0129V82.0454V82.0779V82.1104V82.1429V82.1754V82.2078V82.2403V82.2727V82.3052V82.3376V82.37V82.4024V82.4347V82.4671V82.4995V82.5318V82.5641V82.5965V82.6288V82.6611V82.6933V82.7256V82.7579V82.7901V82.8223V82.8545V82.8867V82.9189V82.9511V82.9832V83.0154V83.0475V83.0796V83.1117V83.1438V83.1758V83.2079V83.2399V83.272V83.304V83.3359V83.3679V83.3999V83.4318V83.4637V83.4956V83.5275V83.5594V83.5912V83.6231V83.6549V83.6867V83.7185V83.7502V83.782V83.8137V83.8454V83.8771V83.9088V83.9404V83.9721V84.0037V84.0353V84.0669V84.0984V84.13V84.1615V84.193V84.2245V84.2559V84.2874V84.3188V84.3502V84.3816V84.4129V84.4442V84.4756V84.5069V84.5381V84.5694V84.6006V84.6318V84.663V84.6941V84.7253V84.7564V84.7875V84.8186V84.8496V84.8806V84.9116V84.9426V84.9736V85.0045V85.0354V85.0663V85.0972V85.128V85.1588V85.1896V85.2203V85.2511V85.2818V85.3125V85.3431V85.3738V85.4044V85.435V85.4655V85.4961V85.5266V85.5571V85.5875V85.6179V85.6483V85.6787V85.7091V85.7394V85.7697V85.7999V85.8302V85.8604V85.8906V85.9207V85.9509V85.9809V86.011V86.0411V86.0711V86.1011V86.131V86.1609V86.1908V86.2207V86.2505V86.2803V86.3101V86.3399V86.3696V86.3993V86.4289V86.4586V86.4882V86.5177V86.5473V86.5768V86.6062V86.6357V86.6651V86.6945V86.7238V86.7531V86.7824V86.8117V86.8409V86.8701V86.8992V86.9283V86.9574V86.9865V87.0155V87.0445V87.0734V87.1023V87.1312V87.1601V87.1889V87.2177V87.2464V87.2751V87.3038V87.3325V87.3611V87.3896V87.4182V87.4467V87.4751V87.5036V87.532V87.5603V87.5887V87.6169V87.6452V87.6734V87.7016V87.7297V87.7578V87.7859V87.8139V87.8419V87.8699V87.8978V87.9257V87.9535V87.9813V88.0091V88.0368V88.0645V88.0921V88.1197V88.1473V88.1748V88.2023V88.2298V88.2572V88.2846V88.3119V88.3392V88.3664V88.3936V88.4208V88.448V88.475V88.5021C94 93.474 89.9692 97.5 85 97.5H13.5C8.52944 97.5 4.5 93.4706 4.5 88.5V73C4.5 71.3431 5.5 70 7.5 70Z"
          />
        </svg>
        <svg
          v-if="item.img === 'terminal'"
          class="item__img"
          width="21px"
          height="21px"
          viewBox="0 0 110 110"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M6 3C6 1.34315 4.65685 0 3 0C1.34315 0 0 1.34315 0 3V98V101H3H98C99.6569 101 101 99.6569 101 98C101 96.3431 99.6569 95 98 95H8.92164L32.3219 66.3997L32.2573 66.3469C33.4256 66.7696 34.6859 67 36 67C39.2374 67 42.1481 65.6015 44.161 63.3756L59.2693 70.5701C59.093 71.3518 59 72.165 59 73C59 79.0751 63.9249 84 70 84C76.0751 84 81 79.0751 81 73C81 69.6143 79.4704 66.5859 77.0645 64.568L92.9875 43.2168L94.1344 51.3519L94.1349 51.3518C94.3356 52.7489 95.5249 53.8454 97.0004 53.8964C98.6562 53.9536 100.045 52.6722 100.103 51.0344C100.11 50.856 100.1 50.6808 100.075 50.51L100.076 50.5099L97.9708 35.579L97.9707 35.579C97.766 34.1215 96.514 33 95 33C94.7903 33 94.5856 33.0215 94.388 33.0625L78.4996 36.0415C77.081 36.2797 76 37.5136 76 39C76 40.6569 77.3431 42 79 42C79.2097 42 79.4144 41.9785 79.612 41.9375L87.5694 40.4455L71.4265 62.0917C70.9596 62.0312 70.4834 62 70 62C66.9251 62 64.1448 63.2617 62.1487 65.2957L46.8194 57.996C46.938 57.3487 47 56.6816 47 56C47 49.9249 42.0751 45 36 45C29.9249 45 25 49.9249 25 56C25 58.6129 25.911 61.0131 27.4328 62.9001L6 89.0958V3ZM36 61C38.7614 61 41 58.7614 41 56C41 53.2386 38.7614 51 36 51C33.2386 51 31 53.2386 31 56C31 58.7614 33.2386 61 36 61ZM75 73C75 75.7614 72.7614 78 70 78C67.2386 78 65 75.7614 65 73C65 70.2386 67.2386 68 70 68C72.7614 68 75 70.2386 75 73Z"
          />
        </svg>
        <svg
          v-if="item.img === 'bots'"
          class="item__img"
          width="21px"
          height="21px"
          viewBox="0 0 110 110"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M56 6C56 7.10457 55.1046 8 54 8C52.8954 8 52 7.10457 52 6C52 4.89543 52.8954 4 54 4C55.1046 4 56 4.89543 56 6ZM60 6C60 8.22085 58.7934 10.1599 57 11.1973V18.0963C75.4704 19.2853 90.973 31.3755 97.141 48H99C103.971 48 108 52.0294 108 57V69C108 73.9706 103.971 78 99 78H97.8308C91.9078 96.5593 74.5235 110 54 110C33.4765 110 16.0922 96.5593 10.1692 78H9C4.02944 78 0 73.9706 0 69V57C0 52.0294 4.02944 48 9 48H10.859C17.027 31.3755 32.5296 19.2853 51 18.0963V11.1973C49.2066 10.1599 48 8.22085 48 6C48 2.68629 50.6863 0 54 0C57.3137 0 60 2.68629 60 6ZM100 64C100 60.5658 99.6237 57.2194 98.91 54H99C100.657 54 102 55.3431 102 57V69C102 70.5523 100.821 71.8293 99.3096 71.9842C99.7634 69.391 100 66.7232 100 64ZM9.09002 54H9C7.34315 54 6 55.3431 6 57V69C6 70.5523 7.17903 71.8293 8.69044 71.9842C8.23663 69.391 8 66.7232 8 64C8 60.5658 8.37634 57.2194 9.09002 54ZM94 64C94 86.0914 76.0914 104 54 104C31.9086 104 14 86.0914 14 64C14 41.9086 31.9086 24 54 24C76.0914 24 94 41.9086 94 64ZM35 43H73C77.9706 43 82 47.0294 82 52V77C82 81.9706 77.9706 86 73 86H35C30.0294 86 26 81.9706 26 77V52C26 47.0294 30.0294 43 35 43ZM21 52C21 44.268 27.268 38 35 38H73C80.732 38 87 44.268 87 52V77C87 84.732 80.732 91 73 91H35C27.268 91 21 84.732 21 77V52Z"
          />
        </svg>
        <svg
          v-if="item.img === 'grids'"
          class="item__img"
          width="21px"
          height="21px"
          viewBox="0 0 110 110"
        >
          <line x1="2.5" y1="-2.5" x2="96.5" y2="-2.5" transform="matrix(1 -4.37114e-08 -4.37114e-08 -1 0 0)" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
          <line x1="2.5" y1="-2.5" x2="96.5" y2="-2.5" transform="matrix(1 -4.37114e-08 -4.37114e-08 -1 0 92)" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
          <line x1="82.5" y1="37.5" x2="82.5" y2="13.5" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
          <line x1="2.5" y1="-2.5" x2="26.5" y2="-2.5" transform="matrix(0 -1 -1 0 14 86)" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
          <line x1="96.5" y1="25.5" x2="68.5" y2="25.5" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
          <line x1="2.5" y1="-2.5" x2="30.5" y2="-2.5" transform="matrix(1 0 0 -1 0 69)" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
          <line x1="56.5" y1="25.5" x2="2.5" y2="25.5" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
          <line x1="2.5" y1="-2.5" x2="56.5" y2="-2.5" transform="matrix(1 0 0 -1 40 69)" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
          <line x1="2.5" y1="-2.5" x2="96.5" y2="-2.5" transform="matrix(1 -4.37114e-08 -4.37114e-08 -1 0 46)" stroke="currentColor" stroke-width="5" stroke-linecap="round"/>
        </svg>
        <svg
          v-if="item.img === 'booster'"
          class="item__img"
          width="21px"
          height="21px"
          viewBox="0 0 110 110"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M84 58H87V55V37.3824L96.6199 36.9976L102.674 36.7554L98.8112 32.0873L74.8112 3.0873L72.3841 0.154552L70.1 3.2L47.6 33.2L44 38H50H58.5V55V58H61.5H84ZM81 34.5V52H64.5V35V32H61.5H56L72.6159 9.84545L90.3255 31.2446L83.8801 31.5024L81 31.6176V34.5ZM19.5 44.5H16.5V47.5V65.1176L6.8801 65.5024L0.825542 65.7446L4.68882 70.4127L28.6888 99.4127L31.1159 102.345L33.4 99.3L55.9 69.3L59.5 64.5H53.5H45V47.5V44.5H42H19.5ZM22.5 68V50.5H39V67.5V70.5H42H47.5L30.8841 92.6546L13.1745 71.2554L19.6199 70.9976L22.5 70.8824V68Z"
          />
        </svg>
        <svg
          v-if="item.img === 'stats'"
          class="item__img"
          width="21px"
          height="21px"
          viewBox="0 0 110 110"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M99.4222 35.1304C101.015 38.9753 102.086 43.0063 102.615 47.1165H61.9999L61.9999 6.50105C66.1101 7.03009 70.1411 8.10155 73.986 9.69416C79.6883 12.0561 84.8695 15.5181 89.2339 19.8825C93.5982 24.2468 97.0602 29.4281 99.4222 35.1304ZM105 53.1165C107.209 53.1165 109.016 51.3231 108.849 49.1203C108.426 43.5286 107.118 38.0307 104.965 32.8343C102.302 26.404 98.398 20.5613 93.4765 15.6398C88.555 10.7183 82.7123 6.81438 76.2821 4.15088C71.0857 1.99847 65.5878 0.690193 59.9961 0.267373C57.7933 0.100803 55.9999 1.90736 55.9999 4.1165L55.9999 47.1165C55.9999 50.4302 58.6862 53.1165 61.9999 53.1165H105ZM52.9999 11.1165C52.9999 12.7465 51.6999 14.0729 50.0801 14.1154C42.3983 14.3508 34.6224 16.4489 27.7105 20.8037C6.95947 33.8779 0.736156 61.2987 13.8104 82.0498C26.8846 102.801 54.3054 109.024 75.0564 95.9499C87.9975 87.7964 95.5383 73.3074 96.001 59.0322C96.0456 57.4143 97.3712 56.1164 98.9999 56.1164C100.657 56.1164 102 57.4596 102 59.1164C102 59.154 101.999 59.1913 101.998 59.2285C101.474 75.3604 92.9909 91.7419 78.2548 101.026C54.7001 115.867 23.5746 108.803 8.73393 85.2482C-6.10671 61.6935 0.957425 30.5679 24.5121 15.7273C32.4163 10.7472 41.2534 8.38335 49.8948 8.11831C49.9297 8.11711 49.9647 8.1165 49.9999 8.1165C51.6567 8.1165 52.9999 9.45965 52.9999 11.1165Z"
          />
        </svg>
        <svg
          v-if="item.img === 'hooks'"
          class="item__img"
          width="21"
          height="21"
          viewBox="0 0 106 107"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M43.03 62.8692L42.997 62.8361L47.2333 58.5871L47.2662 58.6202C53.9181 65.2922 64.7029 65.2922 71.3548 58.6202L94.7303 35.1742C101.382 28.5023 101.382 17.6849 94.7303 11.013C88.0784 4.34104 77.2936 4.34104 70.6417 11.013L55.2852 26.4158L51.0489 22.1668L66.4055 6.76396C75.3969 -2.25465 89.9751 -2.25465 98.9666 6.76396C107.958 15.7826 107.958 30.4046 98.9666 39.4232L75.5911 62.8692C66.5996 71.8879 52.0215 71.8879 43.03 62.8692ZM62.6802 43.7639L62.7131 43.797L58.4769 48.0461L58.444 48.013C51.7921 41.341 41.0072 41.341 34.3554 48.013L10.9799 71.459C4.32799 78.1309 4.32799 88.9483 10.9799 95.6202C17.6317 102.292 28.4166 102.292 35.0685 95.6202L50.425 80.2174L54.6612 84.4664L39.3047 99.8692C30.3132 108.888 15.7351 108.888 6.74362 99.8692C-2.24787 90.8506 -2.24788 76.2285 6.74362 67.2099L30.1191 43.7639C39.1106 34.7453 53.6887 34.7453 62.6802 43.7639Z"
          />
        </svg>
        <span class="item__title">{{ translateMenu(key) }}</span>
      </router-link>
      <div
        class="exit-wrapper"
        style="margin-top: auto"
      >
        <div
          class="item"
          @click="exit()"
        >
          <svg
            width="15"
            height="17"
            viewBox="0 0 90 98"
            xmlns="http://www.w3.org/2000/svg"
            class="item__img"
          >
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M45 0C46.6569 0 48 1.34314 48 3V32C48 33.6569 46.6569 35 45 35C43.3431 35 42 33.6569 42 32V3C42 1.34314 43.3431 0 45 0ZM33.0432 15.8582L33.0464 15.8661C32.9779 15.8881 32.9097 15.9103 32.8413 15.9327C17.2561 21.0418 6 35.7064 6 53C6 74.5392 23.4609 92 45 92C66.5391 92 84 74.5392 84 53C84 37.7566 75.2546 24.5557 62.5074 18.1411C60.7297 17.2465 58.8741 16.4838 56.9536 15.8661L56.8132 15.8212L56.817 15.813C55.6057 15.3889 55 14.2894 55 13C55 11.3431 56 10 58 10C58.8776 10.1462 59.4983 10.3218 59.9375 10.5386C77.448 16.6984 90 33.3834 90 53C90 77.8529 69.8528 98 45 98C20.1472 98 0 77.8529 0 53C0 33.3835 12.5518 16.6986 30.0623 10.5387C30.5015 10.3219 31.1223 10.1463 32 10C34 10 35 11.3431 35 13C35 14.3381 34.3478 15.4716 33.0432 15.8582Z"
            />
          </svg>
          <span class="item__title">{{ $text.tr('ВЫХОД') }}</span>
        </div>
        <a
          class="version menu-version"
          :href="$text.tr('https://doc.capico.app/v/ru/new/updates')"
          target="_blank"
        >
          v {{ version }}
        </a>
      </div>
    </div>
    <ToggleButton
      v-model="isMenuCollapsed"
      targetId="menu"
      :shortcutName="isMenuCollapsed && !isHeaderCollapsed ? '' : 'Q'"
      class="toggle-button"
      :parentObject="{id: 'main', styleProp: 'paddingLeft', defaultValue: '10px'}"
    />
  </div>
</template>

<script>
import ToggleButton from '@/components/common/ToggleButton'
export default {
  name: 'Menu',
  components: { ToggleButton },
  data: function () {
    return {
      selected: 'terminal',
      menuItems: [
        {
          text: 'ПОРТФЕЛЬ',
          href: '/',
          img: 'portfolio'
        },
        {
          text: 'ТЕРМИНАЛ',
          href: '/terminal',
          img: 'terminal'
        },
        {
          text: 'БОТЫ',
          href: '/bots',
          img: 'bots'
        },
        {
          text: 'GRID',
          href: '/grids',
          img: 'grids'
        },
        {
          text: 'BOOSTER',
          href: '/booster',
          img: 'booster'
        },
        {
          text: 'СТАТИСТИКА',
          href: '/stats',
          img: 'stats'
        }
        // {
        //   text: 'СИГНАЛЫ',
        //   href: '/hooks',
        //   img: 'hooks'
        // }
      ]
    }
  },
  computed: {
    version () {
      return process.env.VUE_APP_VERSION
    },
    isMenuCollapsed: {
      get () {
        return this.$store.state.sys.isMenuCollapsed
      },
      set (value) {
        this.$store.state.sys.isMenuCollapsed = value
        localStorage.setItem('isMenuCollapsed', value)
      }
    },
    isHeaderCollapsed () {
      return this.$store.state.sys.isHeaderCollapsed
    }
  },
  methods: {
    translateMenu (ind) {
      return this.$text.tr(this.menuItems[ind].text)
    },
    exit () {
      this.$store.state.sys.tradeExchange = {}
      this.$store.state.sys.token = ''
      this.$store.state.trade.editTrade = null
      localStorage.removeItem('token')
      window.location.href = '/app/login'
      // this.$router.push('/login')
      // this.$router.go()
    }
  }
}
</script>
